<div class="flex items-center justify-center min-h-[100dvh] w-[100dvw] bg-[url('/assets/images/landscapebg.jpeg')] bg-cover bg-no-repeat">
  <div class="w-[min(440px,calc(100%-2rem))] m-6 p-[clamp(2rem,6vw,3rem)] bg-gray-50 rounded-[1.25rem] shadow-xl min-h-[min(450px,85vh)] flex flex-col justify-center gap-4">
    <div class="text-center mb-10">
      <div class="flex items-center justify-center mb-8 w-full">
        <img
          src="assets/images/bannerlogo.png"
          alt="Progres Logo"
          class="p-3.5 w-auto max-w-full object-contain"
        />
      </div>

      <div class="relative text-center my-8 h-px bg-gray-300"></div>

      <p class="font-body text-md text-gray-500 leading-normal">
        Bienvenido al Portal Web de Comunidades de Agronic NET.
      </p>
    </div>

    <lib-button className="w-full" (btnClick)="signIn()">
      <span>Iniciar sesión</span>
    </lib-button>
  </div>
</div>